import { Metamodel } from '../base/model';
import { IModel, IAttribute, IValidationContext, IViolation } from '../base/annotation';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { Named } from '../base/named';

@Metamodel.model({
    name: ModelConstants.eventStreamLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.EventStream_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.EventStream_DisplayText)
    ],
    validator: EventStreamLinkedService.validateEventStreamLinkedService
})
export class EventStreamLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    public static readonly ARTIFACT_ID: IAttribute;
    public static readonly WORKSPACE_ID: IAttribute;

    public static async validateEventStreamLinkedService(
        linkedService: EventStreamLinkedService,
        context: IValidationContext
    ): Promise<IViolation[]> {
        // This is a dummy linked service
        return [];
    }

    public override readonly tridentArtifactType = 'EventStream';

    @Metamodel.attribute({
        display: format(shellStringResources.ObjectIdLabel, shellStringResources.EventStream_DisplayText),
        association: 'ARTIFACT_ID',
        accepts: ['String'],
        templatable: true
    })
    public artifactId?: string;

    @Metamodel.attribute({
        display: shellStringResources.WorkspaceId,
        association: 'WORKSPACE_ID',
        accepts: ['String'],
        templatable: true
    })
    public workspaceId?: string;

    @Metamodel.attribute({
        reference: true
    })
    public parentEntity?: Named;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
